const SHARP_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'] as const;
const FLAT_NAMES = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'] as const;

/** Prefer flats when fifths < 0, else sharps (matches key signature spelling). */
export function preferFlatsFromFifths(keySignatureFifths: number): boolean {
  return keySignatureFifths < 0;
}

/** Pitch class → note name (no octave) using key-signature spelling. */
export function pitchClassToNoteName(pc: number, keySignatureFifths: number): string {
  const names = preferFlatsFromFifths(keySignatureFifths) ? FLAT_NAMES : SHARP_NAMES;
  return names[((pc % 12) + 12) % 12]!;
}

/** MIDI → note name in key (no register), e.g. Ab not G#. */
export function midiToNoteNameInKey(midi: number, keySignatureFifths: number): string {
  const pc = ((midi % 12) + 12) % 12;
  return pitchClassToNoteName(pc, keySignatureFifths);
}

/** @deprecated Use midiToNoteNameInKey — kept for any legacy call sites. */
export function midiToLetterName(midi: number): string {
  const pc = ((midi % 12) + 12) % 12;
  const octave = Math.floor(midi / 12) - 1;
  return `${SHARP_NAMES[pc]}${octave}`;
}

/** Parse tonic like C, F#, Bb → pitch class 0–11. */
export function tonicToPitchClass(tonic: string): number {
  const t = tonic.trim();
  const m = /^([A-Ga-g])([#b♭]?)$/.exec(t);
  if (!m) return 0;
  const letter = m[1]!.toUpperCase();
  const acc = m[2] ?? '';
  const base: Record<string, number> = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
  let pc = base[letter] ?? 0;
  if (acc === '#' || acc === '♯') pc += 1;
  if (acc === 'b' || acc === '♭') pc -= 1;
  return ((pc % 12) + 12) % 12;
}

/** Pitch class → tonic name using key signature fifths for spelling preference. */
export function pitchClassToTonicName(pc: number, keySignatureFifths: number): string {
  return pitchClassToNoteName(pc, keySignatureFifths);
}

/** EasyScore pitch: note + octave, e.g. Ab4, F#5 */
export function midiToEasyScorePitch(midi: number, keySignatureFifths: number): string {
  const pc = ((midi % 12) + 12) % 12;
  const octave = Math.floor(midi / 12) - 1;
  return `${pitchClassToNoteName(pc, keySignatureFifths)}${octave}`;
}
